import type { SkipLinkTarget } from './skipLinkTargets'
import { resolveSkipLinkTarget, SKIP_LINK_TARGETS } from './skipLinkTargets'

export function getAvailableSkipLinkTargets(): SkipLinkTarget[] {
  return SKIP_LINK_TARGETS.filter(({ id }) => resolveSkipLinkTarget(id) !== null)
}
